import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcElectronOperation, RpcElectronOperationResult, RpcElectronRequestKey } from './rpc-electron-model';

export class RpcElectronRequestClient {
    /**
     * The electron request client call.
     *
     * @param data the RpcElectronOperation object.
     * @return Promise<RpcElectronOperationResult> the promise object with operation result.
     */
    public static electronRequest(rpc: Rpc, data: RpcElectronOperation): Promise<RpcElectronOperationResult> {
        return RpcInboundClient.call(rpc, RpcElectronRequestKey.command, RpcElectronRequestKey.version, data);
    }
}
